import React, {useState} from 'react';

const CrpCookieFooter = () => {
    const isCookiePopupShown = localStorage.getItem("isCookiePopupShown");
    const [isCookiePopupVisible, setIsCookiePopupVisible] = useState(true);

    const onClose = () => {
        localStorage.setItem("isCookiePopupShown", "true");
        setIsCookiePopupVisible(false);
    }

    return (
        isCookiePopupVisible && !isCookiePopupShown &&
        (<>
            <style>
                {`
        .crp-floating-footer {
          position: fixed;
          left: 0;
          right: 0;
          bottom: 0;
          background: #db291d;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 16px;
          z-index: 9999;
          box-shadow: 0 -2px 6px rgba(0,0,0,0.2);
          font-size: 14px;
          line-height: 1;
          border-radius: 5px;
          margin: 5px;
        }
        
        .crp-floating-footer__content {
          display: flex;
          align-items: center;
        }
        
        .crp-floating-footer__link {
          color: #fff;
          margin-left: 6px;
        }
        
        .crp-floating-footer__link:hover{
          color: #fff;
          text-decoration: underline;
        }
        
        .crp-floating-footer__close {
          margin-left: 16px;
          background: #3a3a3a;
          color: #fff;
          border: none;
          padding: 6px 10px;
          border-radius: 3px;
          cursor: pointer;
          font-weight: 600;
        }
        
        @media (max-width: 660px) {
        .crp-floating-footer{
                flex-direction: column;
                align-items: flex-start;
                gap: 20px;
                max-width:250px;
         }
         
         .crp-floating-footer__close{
                margin-left: 0px;
          }
        }
      `}
            </style>
            <div className="crp-floating-footer" role="region" aria-label="cookie-info">
                <div className="crp-floating-footer__content">
                    <span>
                        This site uses cookies. To see how cookies are used, please review our
                        <a href="/PrivacyPolicy"
                           target="_blank"
                           className="crp-floating-footer__link">privacy policy</a>
                    </span>
                </div>
                <button
                    type="button"
                    className="crp-floating-footer__close"
                    aria-label="Dismiss cookie message"
                    onClick={onClose}
                >
                    I Agree
                </button>
            </div>
        </>)
    );
};

export default CrpCookieFooter;